<ng-container *ngIf="chartData.cycleCount > 0; else noData">
  <div class="time-cycle-content" [ngClass]="size">
    <div *ngIf="size === 'medium' && showLegend" class="time-cycle-legend">
      *Relative to industry benchmark:
      @for (cat of legendLabels; track $index) {
        <span class="time-cycle-legend-item">
          <div
            class="time-cycle-legend-circle"
            [style.background-color]="categoryColorMap[cat]"
          ></div>
          {{ categoryLabelMap[cat] }}
        </span>
      }
    </div>

    <div class="time-cycle-chart-wrapper" #chartWrapper>
      <div
        echarts
        (chartInit)="onChartInit($event)"
        [initOpts]="INIT_CHART"
        [options]="chartOption"
        [style.height]="getChartContainerHeight()"
        class="time-cycle-chart-container"
        [ngClass]="size"
      ></div>

      <time-cycle-chart-tooltip
        *ngIf="hoveredTooltip as tooltip"
        class="time-cycle-external-tooltip"
        [class.time-cycle-external-tooltip--bar]="hoveredTooltipSource === 'bar'"
        [class.time-cycle-external-tooltip--y-axis]="hoveredTooltipSource === 'yAxis'"
        [title]="tooltip.title"
        [style.left.px]="hoveredTooltipPosition.x"
        [style.top.px]="hoveredTooltipPosition.y"
        [weeks]="tooltip.weeks"
        [status]="tooltip.status"
      ></time-cycle-chart-tooltip>
    </div>
  </div>
</ng-container>

<ng-template #noData>
  <drilldown-chart-no-data-available [size]="size"></drilldown-chart-no-data-available>
</ng-template>
